import { render, staticRenderFns } from "./DeviceDetails.vue?vue&type=template&id=80758aa8&scoped=true"
import script from "./DeviceDetails.vue?vue&type=script&lang=js"
export * from "./DeviceDetails.vue?vue&type=script&lang=js"
import style0 from "./DeviceDetails.vue?vue&type=style&index=0&id=80758aa8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80758aa8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80758aa8')) {
      api.createRecord('80758aa8', component.options)
    } else {
      api.reload('80758aa8', component.options)
    }
    module.hot.accept("./DeviceDetails.vue?vue&type=template&id=80758aa8&scoped=true", function () {
      api.rerender('80758aa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ApparatusDetails/DeviceDetails.vue"
export default component.exports